module.exports = __webpack_public_path__ + "static/media/specification.0f074ce6.md";